<template>
  <div>
    <list-page :changeRecordList="changeRecordList" :flightType="1"></list-page>
  </div>
</template>
<script>
import ListPage from "@/page/distributor/accountsChecking/component/listPage";
export default {
  data() {
    return {
      changeRecordList: [
        { text: "出票订单", value: 1 },
        { text: "退票订单", value: 3 },
        { text: "改签订单", value: 2 },
        { text: "废票订单", value: 4 },
        { text: "其他", value: 5 }
      ]
    };
  },
  components: { ListPage },
  methods: {}
};
</script>
<style lang="less" scoped>
@import "../component/css/index";
</style>